import React, { useEffect, useRef, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import { io } from 'socket.io-client';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix des icônes Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

// Composant pour centrer la carte quand position change
const MapUpdater = ({ position }) => {
  const map = useMap();
  const updateCounter = useRef(0);

  useEffect(() => {
    updateCounter.current += 1;
    if (updateCounter.current % 50 === 0) {
      map.setView(position, map.getZoom(), { animate: true });
    }
  }, [position, map]);

  return null;
};

const TrackerMap = () => {
  const [trackerId, setTrackerId] = useState('12345');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [password, setPassword] = useState('');
  const [showInitForm, setShowInitForm] = useState(false);
  const [position, setPosition] = useState(null);
  const [speed, setSpeed] = useState(0);

  const previousData = useRef({ position: null, timestamp: null });
  const socketRef = useRef(null);

  useEffect(() => {
    if (!trackerId) {
      setPosition(null);
      setSpeed(0);
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
      return;
    }

    const socketUrl =
      process.env.NODE_ENV === 'production'
        ? 'https://rafarostrack-react-web.rafaros-it.fr'
        : 'http://localhost:4000';

    socketRef.current = io(socketUrl, {
      path: '/socket.io',
      transports: ['websocket'],
      secure: true,
    });

    socketRef.current.on('location', (data) => {
      if (data.trackerId !== trackerId) return;

      const lat = parseFloat(data.latitude);
      const lng = parseFloat(data.longitude);
      const speedKmh = parseFloat(data.speedKmh).toFixed(1);

      setPosition([lat, lng]);
      setSpeed(speedKmh);

      previousData.current = {
        position: [lat, lng],
        timestamp: Date.now(),
      };
    });

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [trackerId]);

  const handleSendPosition = () => {
    if (!latitude || !longitude) {
      alert('⚠️ Veuillez saisir la latitude et la longitude !');
      return;
    }
    if (password !== 'grammacks') {
      alert('⛔ Mot de passe incorrect ! Transmission refusée.');
      return;
    }
    socketRef.current.emit('init-position', {
      trackerId,
      latitude: parseFloat(latitude),
      longitude: parseFloat(longitude),
    });
    alert('✅ Position initiale transmise avec succès !');
    setShowInitForm(false);
    setLatitude('');
    setLongitude('');
    setPassword('');
  };

  return (
    <div className="App">
      {/* Header TrackerMap */}
      {/* Header TrackerMap */}
      <header className="tracker-header">
        <h3>Rafaros Track</h3>
        <p>Gps Tracking System</p>

        <input
          type="text"
          placeholder="Enter Tracker ID"
          value={trackerId}
          onChange={(e) => setTrackerId(e.target.value)}
        />
        <button onClick={() => setShowInitForm(!showInitForm)}>
          {showInitForm ? 'Fermer' : 'Destination'}
        </button>

        {showInitForm && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '5px', width: '100%', alignItems: 'center' }}>
            <input
              type="number"
              placeholder="Latitude"
              value={latitude}
              onChange={(e) => setLatitude(e.target.value)}
              step="0.00001"
            />
            <input
              type="number"
              placeholder="Longitude"
              value={longitude}
              onChange={(e) => setLongitude(e.target.value)}
              step="0.00001"
            />
            <input
              type="password"
              placeholder="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button onClick={handleSendPosition}>Transmettre</button>
          </div>
        )}
      </header>


      {/* Affichage vitesse */}
      {position && (
        <div
          style={{
            position: 'absolute',
            top: '10px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1000,
            background: 'rgba(0,0,0,0.75)',
            color: 'white',
            padding: '4px 8px',
            borderRadius: '6px',
            fontSize: '12px',
          }}
        >
        </div>
      )}

      {/* Carte */}
      <div className="map-container">

                🛩️ Drone Militaire : {speed} km/h

        {position ? (
          <MapContainer center={position} zoom={13} className="leaflet-container">
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <MapUpdater position={position} />
            <Marker position={position}>
              <Popup>
                <div>
                  <div><strong>Position</strong></div>
                  Lat: {position[0].toFixed(5)}<br />
                  Lng: {position[1].toFixed(5)}<br />
                  <div><strong>Vitesse</strong>: {speed} km/h</div>
                </div>
              </Popup>
            </Marker>
          </MapContainer>
        ) : (
          <div
            style={{
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '18px',
            }}
          >
            Chargement de la carte...
          </div>
        )}
      </div>
    </div>
  );
};

export default TrackerMap;
